<template>
  <div>
    <ExecutionLogTable :orderCode="orderCode" :disabled="disabled" />
  </div>
</template>
<script>
import ExecutionLogTable from './components/table'
export default {
  components: { ExecutionLogTable },
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
